<template>
    <div>
        <el-container class="home-container">
            <el-header style="text-align: right; font-size: 12px" v-if="headerInfoVisible">
                <!-- <span>用户</span> -->
                <el-dropdown trigger="click">
                    <div class="avatar-wrapper">
                        <img src="../../public/icon_avatar.png" class="user-avatar">
                        <i class="el-icon-caret-bottom" />
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <span style="display:block;">{{ $store.getters.name }}</span>
                        </el-dropdown-item>
                        <el-dropdown-item @click.native="logout">
                            <span style="display:block;">退出</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-header>
            <el-container class="container">
                <el-aside width="200px">
                    <el-menu :default-active="active" :default-openeds="openActive" class="el-menu-vertical-demo"
                        background-color="#fff" text-color="#304156" active-text-color="#409EFF" @select="changeView"
                        style="overflow-x: hidden;width: 180px;">
                        <template v-for="item in menuItems">
                            <el-submenu v-if="item.menuType === 'C'" :index="item.index" :key="item.index">
                                <template slot="title">
                                    <i :class="item.icon"></i>
                                    <span>{{ item.menuName }}</span>
                                </template>
                                <el-menu-item v-for="child in item.children" :key="child.index" :index="child.index">
                                    <span>{{ child.menuName }}</span>
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="item.index" :key="item.index">
                                <i :class="item.icon"></i>
                                <span>{{ item.menuName }}</span>
                            </el-menu-item>
                        </template>
                    </el-menu>
                </el-aside>

                <el-main>
                    <div v-if="frameSrc">
                        <iframe :src="frameSrc" style="width:100%;height:100%;border:none;"></iframe>
                    </div>
                    <component :is="currentView" v-else v-if="update"></component>
                </el-main>
            </el-container>

        </el-container>
    </div>
</template>

<script>
import taskManagement from "./integration/taskManagement.vue";//任务管理,医生工作台
import homeDiabetes from "./diabetes/homeDiabetes.vue";//糖尿病首页
import bloodGlucoseMonitor from "./diabetes/bloodGlucoseMonitor.vue";//血糖检测
import bloodPressureMonitor from "./BloodPressure/bloodPressureMonitor.vue";//血压检测
import assessment from "./assessment/assessment.vue"//易患筛查
import evaluationList from "./cardiovascularEvaluation/evaluationList.vue"//心血管评估
import patientManagement from "./patient/patientManagement/patientManagement.vue";//患者管理
import patientList from "./patient/patientList.vue";//个人档案
import homePatientList from "./patient/homePatientList.vue";//家庭档案
import followupHome from "./followup/followupHome.vue";//随访管理
import collaborativeManagement from "./collaborativeManagement/collaborativeManagement.vue"//协诊管理
import taskManagementLung from "./integration/taskManagementLung.vue";
import followupHomeLung from "./followupLung/followupHome.vue";
import collaborativeManagementLung from "./collaborativeManagementLung/collaborativeManagement.vue"//协诊管理
import { getMenu } from "@/api/user"
import { getUserInfos, } from "@/api/health/Patients";
import patientLung from "./patientLung/patientManagement.vue";//患者管理
import statisticsLung from "./statisticsLung/statisticsLung.vue";

export default {
    components: {
        homeDiabetes,
        patientList,
        patientLung,
        homePatientList,
        bloodGlucoseMonitor,
        bloodPressureMonitor,
        followupHome,
        collaborativeManagement,
        assessment,
        evaluationList,
        patientManagement,
        taskManagement,
        taskManagementLung,
        followupHomeLung,
        collaborativeManagementLung,
        statisticsLung
    },
    data() {
        return {
            active: "1",
            openActive: ['1', '2', '4'],
            currentView: "taskManagement",
            pInfo: null,
            update: true,
            headerInfoVisible: true,
            menuItems: [],
            menuItems1: [
                { menuId: 10, menuName: "医生工作台", children: [] },
                {
                    menuId: 20,
                    menuName: "人群管理",
                    children: [
                        { menuId: 21, menuName: "患者管理", children: [] },
                        { menuId: 22, menuName: "居民档案", children: [] },
                        { menuId: 23, menuName: "家庭档案", children: [] }
                    ]
                },
                {
                    menuId: 30,
                    menuName: "健康检测",
                    children: [
                        { menuId: 31, menuName: "血糖检测", children: [] },
                        { menuId: 32, menuName: "血压检测", children: [] },
                        { menuId: 33, menuName: "易患筛查", children: [] },
                        { menuId: 34, menuName: "心血管评估", children: [] }
                    ]
                },
                { menuId: 40, menuName: "随访管理", children: [] },
                { menuId: 50, menuName: "协诊管理", children: [] },

            ],
            menuItems2: [
                { menuId: 11, menuName: "医生工作台(Lung)", children: [] },
                { menuId: 14, menuName: "患者管理(Lung)", children: [] },
                { menuId: 41, menuName: "随访管理(Lung)", children: [] },
                { menuId: 51, menuName: "协诊管理(Lung)", children: [] },
                { menuId: 61, menuName: "统计分析(Lung)", children: [] },
            ],
            labelToView: {
                '医生工作台': 'taskManagement',
                '居民档案': 'patientList',
                '家庭档案': 'homePatientList',
                '患者管理': 'patientManagement',
                '血糖检测': 'bloodGlucoseMonitor',
                '血压检测': 'bloodPressureMonitor',
                '易患筛查': 'assessment',
                '心血管评估': 'evaluationList',
                '随访管理': 'followupHome',
                '协诊管理': 'collaborativeManagement',
                '医生工作台(Lung)': 'taskManagementLung',
                '患者管理(Lung)': 'patientLung',
                '随访管理(Lung)': 'followupHomeLung',
                '协诊管理(Lung)': 'collaborativeManagementLung',
                '统计分析(Lung)': 'statisticsLung',
            },
            frameSrc: null
        };
    },
    created() {
        this.headerInfoVisible = window.__POWERED_BY_QIANKUN__ ? false : true;
        this.fetchMenu()
    },
    watch: {
        frameSrc: {
            handler(newVal, oldVal) {
                console.warn("frameSrc: ", newVal, oldVal)
            },
            deep: true
        },
        currentView: {
            handler(newVal, oldVal) {
                console.warn("currentView: ", newVal, oldVal)
            },
            deep: true
        }
    },
    methods: {
        async logout() {
            await this.$store.dispatch('user/logout')
            this.$router.push(`/login?redirect=${this.$route.fullPath}`)

            // this.$router.push({
            //     path: "/login",
            // }).catch(() => {
            //     //此处可以添加一个弹窗，例如：
            //     alert('请先登录')
            // })

            // this.$router.go(`/login`)

        },
        async fetchMenu() {
            let isLung = false;
            try {
                const res = await getUserInfos({});
                if (res.data?.deptId === '206' && res.data?.deptName === '综合外科普外胸外血管外科门诊') {
                    isLung = true;
                    this.currentView = 'taskManagementLung';
                } else {
                    isLung = false;
                    this.currentView = 'taskManagement';
                }
                console.warn("isLung: ", isLung,this.currentView)
                await getMenu().then(res => {
                    const list = res && res.data ? res.data : []
                    let menus = [...this.menuItems1];
                    if (isLung) {
                        menus = [...this.menuItems2]
                    }
                    // menus = [...this.menuItems2, ...this.menuItems1];
                    const items = this.transformMenu(menus && menus.length ? menus : list)
                    console.warn("transformed menu: ", items)
                    this.menuItems = items
                    this.openActive = items.filter(i => i.children && i.children.length).map(i => i.index)
                    const firstClickable = (() => {
                        for (let i = 0; i < items.length; i++) {
                            const it = items[i]
                            if (it.children && it.children.length && this.isParentClickable(it)) return it.index + '-0'
                            if (!it.children || !it.children.length) return it.index
                            if (it.children && it.children.length) return it.children[0].index
                        }
                        return null
                    })()
                    if (firstClickable) this.active = firstClickable
                }).catch(() => {
                    const def = [
                        { label: '医生工作台', icon: 'el-icon-s-platform' },
                        {
                            label: '健康档案', icon: 'el-icon-folder', children: [
                                { label: '居民档案' },
                                { label: '家庭档案' }
                            ]
                        },
                        { label: '患者管理', icon: 'el-icon-s-custom' },
                        {
                            label: '健康检测', icon: 'el-icon-first-aid-kit', children: [
                                { label: '血糖检测' },
                                { label: '血压检测' },
                                { label: '易患筛查' },
                                { label: '心血管评估' }
                            ]
                        },
                        { label: '随访管理', icon: 'el-icon-wallet' },
                        { label: '协诊管理', icon: 'el-icon-edit-outline' }
                    ]
                    const items = this.transformMenu(def)
                    this.menuItems = items
                    this.openActive = items.filter(i => i.children && i.children.length).map(i => i.index)
                    console.warn("openActive: ", this.openActive)
                })
            } catch (e) { }
        },
        transformMenu(list) {
            const hasChildren = Array.isArray(list) && list.length && Array.isArray(list[0].children)
            const isFlat = Array.isArray(list) && list.length && !Array.isArray(list[0].children)
            if (hasChildren) {
                let idx = 1
                return list.map(top => {
                    const pIndex = String(top.menuId || idx++)
                    const children = (top.children || []).map((c, i) => ({
                        index: `${pIndex}-${c.menuId || (i + 1)}`,
                        menuName: c.menuName,
                        icon: c.icon || '',
                        isFrame: c.isFrame || '0',
                        path: c.path || c.url || '',
                        menuType: c.menuType || ''
                    }))
                    return {
                        index: pIndex,
                        menuName: top.menuName,
                        icon: top.icon || '',
                        children,
                        menuType: top.menuType || (children.length ? 'C' : ''),
                        isFrame: top.isFrame || '0',
                        path: top.path || top.url || ''
                    }
                })
            } else if (isFlat) {
                const nodeMap = {}
                list.forEach(it => {
                    const name = it.menuName || it.name || it.label
                    if (!nodeMap[name]) {
                        nodeMap[name] = { menuId: it.menuId, menuName: name, icon: it.icon || '', children: [], menuType: it.menuType || '', isFrame: it.isFrame || '0', path: it.path || it.url || '' }
                    } else {
                        nodeMap[name].menuType = nodeMap[name].menuType || it.menuType || ''
                        nodeMap[name].isFrame = nodeMap[name].isFrame || it.isFrame || '0'
                        nodeMap[name].path = nodeMap[name].path || it.path || it.url || ''
                        nodeMap[name].icon = nodeMap[name].icon || it.icon || ''
                        nodeMap[name].menuId = nodeMap[name].menuId || it.menuId
                    }
                })
                const roots = []
                list.forEach(it => {
                    const name = it.menuName || it.name || it.label
                    const parentName = it.parentName
                    const node = nodeMap[name]
                    if (parentName && nodeMap[parentName]) {
                        nodeMap[parentName].children.push(node)
                    } else {
                        roots.push(node)
                    }
                })
                return roots.map(top => {
                    const pIndex = String(top.menuId || top.menuName)
                    const children = (top.children || []).map((c, i) => ({
                        index: `${pIndex}-${c.menuId || (i + 1)}`,
                        menuName: c.menuName,
                        icon: c.icon || '',
                        isFrame: c.isFrame || '0',
                        path: c.path || c.url || '',
                        menuType: c.menuType || ''
                    }))
                    return {
                        index: pIndex,
                        menuName: top.menuName,
                        icon: top.icon || '',
                        children,
                        menuType: (top.menuType && top.menuType.length) ? top.menuType : (children.length ? 'C' : ''),
                        isFrame: top.isFrame || '0',
                        path: top.path || top.url || ''
                    }
                })
            }
            return list;
        },
        findNodeByIndex(index) {
            for (let i = 0; i < this.menuItems.length; i++) {
                const item = this.menuItems[i]
                if (item.index === index) return item
                if (item.children && item.children.length) {
                    for (let j = 0; j < item.children.length; j++) {
                        const c = item.children[j]
                        if (c.index === index) return c
                    }
                }
            }
            return null
        },
        isParentClickable(item) {
            if (!item.children || !item.children.length) return false
            if (item.menuType === 'C') return true
            return false
        },
        changeView(view) {
            console.warn("changeView: ", view)
            this.update = false
            let node = null
            if (view && view.endsWith('-0')) {
                const base = view.split('-')[0]
                node = this.findNodeByIndex(base)
            } else {
                node = this.findNodeByIndex(view)
            }
            this.active = view
            if (node && node.isFrame === '1' && node.path) {
                this.frameSrc = node.path
                this.currentView = null
            } else {
                this.frameSrc = null
                const name = node ? node.menuName : null
                const comp = name && this.labelToView[name] ? this.labelToView[name] : 'taskManagement'
                this.currentView = comp
                console.warn('currentView: ', this.currentView)
            }
            this.$nextTick(() => {
                this.update = true
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.el-header,
.el-footer {
    background-color: #ECF5FF;
    color: #333;
    text-align: center;
    line-height: 60px;
}

.container {
    height: 100%
}

.home-container {
    height: 100%;
    margin: 0px;
    direction: vertical;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 180px;
    height: 100%;
    overflow-y: hidden;
    overflow-x: hidden;
    // background-color: #304156;
    background-color: #fff;
}

// .el-menu {
//     margin: 0;
//     padding: 0;
// }

.el-menu {
    border: none;
    height: 100%;
    width: 180px !important;
}

.el-aside {
    border: none;
    padding: 0;
    height: calc(100vh);
    overflow-y: hidden;
    overflow-x: hidden;
    // background-color: #304156;
    background-color: #fff;
    margin-bottom: 0px;
    margin-left: 0px;
    margin-top: 0px;
}

.avatar-wrapper {
    margin-top: 10px;
    position: relative;

    .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
    }

    .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
    }
}
</style>
